import AllEpisodes from './AllEpisodes';

export default AllEpisodes;
